import { useGetActivity } from 'api';

export const TARGET_CHART_TOTAL_DATA_POINT_COUNT = 5000;
export const ACTIVITY_BUFFER = 0.03; // 3% activity buffer
export const PERIOD_BUFFER = 0.04; // 4% period buffer
export const ACTIVITY_INCLUDES: Parameters<typeof useGetActivity>[1] = ['periods.period_athletes.rotations'];
